module.exports = __webpack_public_path__ + "img/ascensor.5a7cac07.svg";